import { Controller } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { twMerge } from 'tailwind-merge';

const BaseDropdown = (props) => {
    const {
        id,
        name,
        label,
        required = false,
        errors,
        className,
        placeholder,
        inputClassName,
        disabled = false,
        control,
        clearErrors,
        value,
        setValue,
        options,
        showClear,
        filter = true,
        onFilter,
        onChange
    } = props;

    const errorClassname = errors?.length ? 'border-theme1-error' : '';

    return (
        <div className={twMerge('w-full', className)}>
            {label && <div className='text-theme1-primary2 font-bold text-base mb-1'>{label}</div>}
            {control && (
                <Controller
                    render={({ field }) => (
                        <Dropdown
                            id={id ?? name}
                            name={name}
                            value={field.value}
                            onChange={(e) => {
                                field.onChange(e.value);
                                if (clearErrors) {
                                    clearErrors(name);
                                }
                            }}
                            placeholder={placeholder ?? label}
                            required={required}
                            disabled={disabled}
                            className={twMerge(
                                'text-theme1-text1 rounded-2xl border border-theme1-text3 w-full outline-0 focus:outline-0 shadow-none text-base',
                                errorClassname,
                                inputClassName
                            )}
                            filter={filter}
                            onFilter={onFilter}
                            options={options}
                            dropdownIcon={
                                <svg
                                    width='22'
                                    height='22'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path d='M6 12L9 15L12 12' strokeLinecap='round' strokeLinejoin='round' />
                                    <path d='M6 6L9 3L12 6' strokeLinecap='round' strokeLinejoin='round' />
                                </svg>
                            }
                            collapseIcon={
                                <svg
                                    width='22'
                                    height='22'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path d='M6 12L9 15L12 12' strokeLinecap='round' strokeLinejoin='round' />
                                    <path d='M6 6L9 3L12 6' strokeLinecap='round' strokeLinejoin='round' />
                                </svg>
                            }
                            appendTo='self'
                            showClear={showClear}
                        />
                    )}
                    control={control}
                    name={name}
                />
            )}

            {!control && (
                <Dropdown
                    id={id ?? name}
                    name={name}
                    value={value}
                    onChange={(e) => {
                        if (onChange) {
                            onChange(e);
                        } else if (setValue) {
                            setValue(e.value);
                        }
                    }}
                    placeholder={placeholder ?? label}
                    required={required}
                    disabled={disabled}
                    className={twMerge(
                        'text-theme1-text1 rounded-2xl border border-theme1-text3 w-full outline-0 focus:outline-0 shadow-none text-base',
                        errorClassname,
                        inputClassName
                    )}
                    filter={filter}
                    onFilter={onFilter}
                    options={options}
                    dropdownIcon={
                        <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M6 12L9 15L12 12' strokeLinecap='round' strokeLinejoin='round' />
                            <path d='M6 6L9 3L12 6' strokeLinecap='round' strokeLinejoin='round' />
                        </svg>
                    }
                    collapseIcon={
                        <svg width='22' height='22' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M6 12L9 15L12 12' strokeLinecap='round' strokeLinejoin='round' />
                            <path d='M6 6L9 3L12 6' strokeLinecap='round' strokeLinejoin='round' />
                        </svg>
                    }
                    appendTo='self'
                    showClear={showClear}
                />
            )}

            {errors &&
                errors.map((error) => {
                    return (
                        <div key={error} className='mt-2.5 text-theme1-error'>
                            {error}
                        </div>
                    );
                })}
        </div>
    );
};

export default BaseDropdown;
